/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_Delete_HintInputs */

const en_admin_questionnaire_editor_delete_hint = /** @type {(inputs: Admin_Questionnaire_Editor_Delete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By deleting this question, it will be removed from your current members’ profiles, but you can still find the answers in your member CSV download.`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_Delete_HintInputs) => LocalizedString} */
const de_admin_questionnaire_editor_delete_hint = en_admin_questionnaire_editor_delete_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Delete_HintInputs) => LocalizedString} */
const es_admin_questionnaire_editor_delete_hint = en_admin_questionnaire_editor_delete_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Delete_HintInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_delete_hint = en_admin_questionnaire_editor_delete_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Delete_HintInputs) => LocalizedString} */
const it_admin_questionnaire_editor_delete_hint = en_admin_questionnaire_editor_delete_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Delete_HintInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_delete_hint = en_admin_questionnaire_editor_delete_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Delete_HintInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_delete_hint = en_admin_questionnaire_editor_delete_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Delete_HintInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_delete_hint = en_admin_questionnaire_editor_delete_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Delete_HintInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_delete_hint = en_admin_questionnaire_editor_delete_hint;

/**
* | output |
* | --- |
* | "By deleting this question, it will be removed from your current members’ profiles, but you can still find the answers in your member CSV download." |
*
* @param {Admin_Questionnaire_Editor_Delete_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_delete_hint = /** @type {((inputs?: Admin_Questionnaire_Editor_Delete_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_Delete_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_delete_hint(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_delete_hint(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_delete_hint(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_delete_hint(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_delete_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_delete_hint(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_delete_hint(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_delete_hint(inputs)
	return ro_admin_questionnaire_editor_delete_hint(inputs)
});
export { admin_questionnaire_editor_delete_hint as "admin.questionnaire_editor.delete_hint" }